import React from "react";
import Input from "../../UI/Input/Input";
import Button from "../../UI/Button/Button";
import Select from "../../UI/Select/Select";
import ContentForm from "../../UI/ContentForm/ContentForm";
import { updateObject, checkValidity } from "../../../shared/utility";
import "./KioskForm.css";
import Fade from "react-reveal/Fade";
import FetchData from "../../../shared/fetchData";
import Map from "../../UI/Map/Map";

const KioskForm = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [changeForm, setChangeForm] = React.useState(false);
  const [showFormDetails, setShowFormDetails] = React.useState(false);
  const [invalidSelect, setInvalidSelect] = React.useState(false);
  const [invalidShift, setInvalidShift] = React.useState(false);
  const [finalized, setFinalized] = React.useState(false);
  const [id, setId] = React.useState("");
  const [kioskTypes, setKioskTypes] = React.useState(props.kioskTypes);
  const [kioskType, setKioskType] = React.useState("");
  const [lat, setLat] = React.useState(35.7575);
  const [lon, setLon] = React.useState(51.4099);
  const [zoom, setZoom] = React.useState(14);
  const [zones, setZones] = React.useState(props.zones);
  const [zone, setZone] = React.useState("");
  const [proviances, setProviances] = React.useState([]);
  const [geoNames, setGeoNames] = React.useState([]);
  const [proviance, setProviance] = React.useState("");
  const [geoName, setGeoName] = React.useState("");
  const [kiosk, setKiosk] = React.useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    postalCode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "کد پستی",
      },
      validation: {
        minLenght: 10,
        maxLength: 10,
        required: false,
      },
      errorMessage: "کد پستی ده رقمی را وارد کنید",
      valid: true,
      value: "",
    },
    address: {
      elementType: "input",
      elementConfig: {
        type: "textarea",
        placeholder: "آدرس",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
    addressEn: {
      elementType: "input",
      elementConfig: {
        type: "textarea",
        placeholder: "آدرس انگلیسی",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
  });

  React.useEffect(() => {
    var info = {
      geoName: {
        type: "PRV",
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/geonames/getGeoNames";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((resultPrv) => {
        setProviances(resultPrv.geoNames);
        if (props.edit == true) {
          const lckrTp = kiosk;
          const prv = resultPrv.geoNames?.filter(
            (g) => g.id === props.kiosk.city?.parentId
          );
          if (!!prv && prv.length > 0) {
            setProviance({ value: prv[0].id, label: prv[0].description });

            var info = {
              geoName: {
                type: "CTY",
                parentId: prv[0].id,
              },
              pl: 1000,
              pn: 1,
              version: "mtpx001",
            };
            var raw = JSON.stringify(info);
            var url = "management/api/v1/geonames/getGeoNames";
            FetchData(raw, url)
              .then((response) => response.json())
              .then((resultGeo) => {
                setGeoNames(resultGeo.geoNames);
                const geo = resultGeo.geoNames?.filter(
                  (g) => g.id === props.kiosk.city?.id
                );
                setGeoName({ value: geo[0].id, label: geo[0].description });
              })
              .catch((error) => console.log(error));
          }
          lckrTp.description.value = props.kiosk.description;
          lckrTp.postalCode.value = props.kiosk.postalCode;
          lckrTp.address.value = props.kiosk.address;
          lckrTp.addressEn.value = props.kiosk.addressEn;
          setLat(props.kiosk.lat);
          setLon(props.kiosk.lon);
          setFinalized(props.kiosk.finalized);
          if (props.kiosk.kioskType != null) {
            setKioskType({
              value: props.kiosk.kioskType.id,
              label: props.kiosk.kioskType.description,
            });
          }
          if (props.kiosk.zone != null) {
            setZone({
              value: props.kiosk.zone.id,
              label: props.kiosk.zone.description,
            });
          }
          setKiosk(lckrTp);
          setEdit(true);
          setId(props.kiosk.id);
        }
      })
      .catch((error) => console.log(error));
  }, []);
  const provianceChange = (value) => {
    setProviance(value);
    var info = {
      geoName: {
        type: "CTY",
        parentId: value?.value,
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/geonames/getGeoNames";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setGeoNames(result.geoNames);
      })
      .catch((error) => console.log(error));
  };

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(kiosk, {
      [controlName]: updateObject(kiosk[controlName], {
        value: event.target.value,
        valid: checkValidity(event.target.value, kiosk[controlName].validation),
      }),
    });
    setKiosk(updatedControls);
  };

  const kioskSubmit = (event) => {
    let valid = true;
    if (kioskType == null || kioskType == "") {
      valid = false;
      setInvalidSelect(true);
    }
    if (zone == null || zone == "") {
      valid = false;
      setInvalidSelect(true);
    }
    const shifts = [];
    for (let key in props.kioskShifts) {
      shifts.push({
        id: props.kioskShifts[key],
      });
    }
    if (shifts == null || shifts.length == 0) {
      valid = false;
      setInvalidShift(true);
    }
    if (valid) {
      if (!edit) {
        setLoading(true);
        const lckrTp = kiosk;
        var raw = JSON.stringify({
          kiosk: {
            description: lckrTp.description.value,
            postalCode: lckrTp.postalCode.value,
            address: lckrTp.address.value,
            addressEn: lckrTp.addressEn.value,
            city: { id: geoName?.value },
            lat: lat,
            lon: lon,
            kioskType: {
              id: kioskType != null && kioskType != "" ? kioskType.value : "",
            },
            zone: {
              id: zone != null && zone != "" ? zone.value : "",
            },
            shifts: shifts,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/kiosks/insertKiosk";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewLockerForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      } else {
        setLoading(true);
        const lckrTp = kiosk;
        var raw = JSON.stringify({
          kiosk: {
            id: id,
            description: lckrTp.description.value,
            postalCode: lckrTp.postalCode.value,
            address: lckrTp.address.value,
            addressEn: lckrTp.addressEn.value,
            city: { id: geoName?.value },
            lat: lat,
            lon: lon,
            kioskType: {
              id: kioskType != null && kioskType != "" ? kioskType.value : "",
            },
            zone: {
              id: zone != null && zone != "" ? zone.value : "",
            },
            shifts: shifts,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/kiosks/updateKiosk";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewLockerForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      }
    }
  };

  const changeMapHandler = (event) => {
    let lat = event.target.getCenter().lat;
    let lng = event.target.getCenter().lng;
    let zoom = event.target.getZoom();
    let ksk = kiosk;
    setLat(lat);
    setLon(lng);
    setZoom(zoom);
    var addressRaw = JSON.stringify({ lat: lat, lon: lng, version: "mtpx001" });
    var addressUrl = "api/v1/geonames/getLatLonDesc";
    FetchData(addressRaw, addressUrl)
      .then((response) => response.json())
      .then((result) => {
        ksk.address.value = result.text;
        ksk.address.valid = true;
        setKiosk(ksk);
        if (changeForm) {
          setChangeForm(false);
        } else {
          setChangeForm(true);
        }
      });
  };

  const changeLocation = (lat, lng) => {
    let ksk = kiosk;
    var addressRaw = JSON.stringify({ lat: lat, lon: lng, version: "mtpx001" });
    var addressUrl = "api/v1/geonames/getLatLonDesc";
    setLat(lat);
    setLon(lng);
    FetchData(addressRaw, addressUrl)
      .then((response) => response.json())
      .then((result) => {
        ksk.address.value = result.text;
        ksk.address.valid = true;
        setKiosk(ksk);
        if (changeForm) {
          setChangeForm(false);
        } else {
          setChangeForm(true);
        }
      });
  };

  const changeKioskType = (selectedOption) => {
    setKioskType(selectedOption);
    setInvalidSelect(false);
  };

  const changeZone = (selectedOption) => {
    setZone(selectedOption);
    setInvalidSelect(false);
  };
  const toggleFromDetails = (event, value) => {
    if (value == true) {
      let valid = true;
      if (proviance == null || proviance == "") {
        valid = false;
        setInvalidSelect(true);
      }
      if (geoName == null || geoName == "") {
        valid = false;
        setInvalidSelect(true);
      }
      const ksk = kiosk;
      for (let key in kiosk) {
        console.log(ksk[key].validation);
        if (!checkValidity(ksk[key].value, ksk[key].validation)) {
          ksk[key].valid = false;
          valid = false;
        }
      }
      if (valid) {
        setInvalidSelect(false);
        setShowFormDetails(value);
      } else {
        setKiosk(ksk);
        if (changeForm) {
          setChangeForm(false);
        } else {
          setChangeForm(true);
        }
      }
    } else {
      setShowFormDetails(value);
    }
  };

  const geoNameChange = (value) => {
    setLat(parseFloat(value.lat));
    setLon(parseFloat(value.lon));
    setGeoName(value);
  };

  const shiftList =
    props.shifts != null && props.shifts.length != 0
      ? props.shifts.map((s) => {
          return (
            <div className="col-3 full-small">
              <label className="container role-text">
                {s.startTime}-{s.endTime}
                <input
                  type="checkbox"
                  onChange={(event) => props.addShift(event, s.id)}
                  checked={
                    props.kioskShifts !== null &&
                    props.kioskShifts.length != 0 &&
                    props.kioskShifts.includes(s.id)
                  }
                  value="ENVELOPE"
                  id="flexCheckDefault"
                />
                <span className="checkmark"></span>
              </label>
            </div>
          );
        })
      : "";
  const formElementsArray = [];
  for (let key in kiosk) {
    formElementsArray.push({
      id: key,
      config: kiosk[key],
    });
  }
  let provianceList = [];
  if (proviances != null && proviances.length != 0) {
    let prvns = [...proviances];
    prvns.map((b) => {
      provianceList.push({
        value: b.id,
        label: b.description,
      });
    });
  }
  let geoNameList = [];
  if (geoNames != null && geoNames.length != 0) {
    let gnms = [...geoNames];
    gnms.map((b) => {
      geoNameList.push({
        value: b.id,
        lat: b.lat,
        lon: b.lon,
        label: b.description,
      });
    });
  }
  let form = formElementsArray.map((formElement) => {
    let col = "6 mt-2";
    if (formElement.config.elementConfig.type == "textarea") {
      col = formElement.id == "addressEn" ? "12 EN-input" : "12 mt-4";
    }
    if (formElement.id == "address") {
      return (
        <div className="ksk-form-map p-0" style={{ padding: "0" }}>
          <div className="row justify-content-center w-100 ml-0 mr-0">
            <Select
              name="form-field-name"
              value={proviance}
              placeholder="استان"
              options={provianceList}
              className={
                invalidSelect && (proviance == null || proviance == "")
                  ? "invalid-select"
                  : ""
              }
              onChange={provianceChange}
              col="6 mt-3"
            />
            <Select
              name="form-field-name"
              value={geoName}
              placeholder="شهر"
              className={
                invalidSelect && (geoName == null || geoName == "")
                  ? "invalid-select"
                  : ""
              }
              options={geoNameList}
              onChange={geoNameChange}
              col="6 mt-3"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <Map
                cityId={"تهران"}
                lat={lat}
                lng={lon}
                zoom={zoom}
                latLngChangeHandler={changeMapHandler}
                changeLocation={changeLocation}
              />
            </div>
            <Input
              key={formElement.id}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              value={formElement.config.value}
              invalid={!formElement.config.valid}
              shouldValidate={formElement.config.validation}
              placeholder={formElement.config.placeholder}
              errorMessage={formElement.config.errorMessage}
              search={true}
              col={col}
              changed={(event) => inputChangedHandler(event, formElement.id)}
            />
          </div>
        </div>
      );
    } else {
      return (
        <Input
          key={formElement.id}
          elementType={formElement.config.elementType}
          elementConfig={formElement.config.elementConfig}
          value={formElement.config.value}
          invalid={!formElement.config.valid}
          shouldValidate={formElement.config.validation}
          placeholder={formElement.config.placeholder}
          errorMessage={formElement.config.errorMessage}
          search={true}
          col={col}
          // className={formElement.id == "description" ? " pl-5 mr-3" : ""}
          changed={(event) => inputChangedHandler(event, formElement.id)}
        />
      );
    }
  });
  let kioskTypeList = [];
  if (kioskTypes != null && kioskTypes.length != 0) {
    kioskTypes.map((k) => {
      kioskTypeList.push({
        value: k.id,
        label: k.description,
      });
    });
  }

  let zoneList = [];
  if (zones != null && zones.length != 0) {
    zones.map((z) => {
      zoneList.push({
        value: z.id,
        label: z.description,
      });
    });
  }

  return (
    <div>
      {!showFormDetails ? (
        <Fade duration={200} left cascade>
          <div>
            <div className="row justify-content-center">
              <div className="ksk-cntnr">
                <ContentForm headetText="اطلاعات لاکر">
                  <div className="ksk-frm">{form}</div>
                  <div className="col-12">
                    <div className="row justify-content-center w-100 mt-3">
                      <div className="col-6 text-center">
                        <Button
                          btnType="General"
                          clicked={(event) =>
                            props.toggleNewLockerForm(event, false)
                          }
                        >
                          برگشت
                        </Button>
                      </div>
                      <div className="col-6 text-center">
                        <Button
                          btnType="Success"
                          clicked={(event) => toggleFromDetails(event, true)}
                        >
                          بعدی
                        </Button>
                      </div>
                    </div>
                  </div>
                </ContentForm>
              </div>
            </div>
          </div>
        </Fade>
      ) : (
        <Fade duration={200} left cascade>
          <div>
            <div className="row justify-content-center">
              <div className="ksk-cntnr">
                <ContentForm headetText="اطلاعات لاکر">
                  <div className="ksk-frm">
                    {invalidShift &&
                    (props.kioskShifts == null ||
                      props.kioskShifts.length == 0) ? (
                      <div className="col-12">
                        <div className="err-shft">
                          شیفت های مربوط به لاکر را انتخاب کنید
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <Select
                      name="form-field-name"
                      value={kioskType}
                      placeholder="نوع لاکر"
                      options={kioskTypeList}
                      onChange={changeKioskType}
                      col={[
                        "6 mt-2",
                        finalized === "1" ? "disable-div" : "",
                      ].join(" ")}
                      className={
                        invalidSelect && (kioskType == null || kioskType == "")
                          ? "invalid-select"
                          : ""
                      }
                    />
                    <Select
                      name="form-field-name"
                      value={zone}
                      placeholder="zone"
                      options={zoneList}
                      onChange={changeZone}
                      col="6 mt-2"
                      className={
                        invalidSelect && (zone == null || zone == "")
                          ? "invalid-select"
                          : ""
                      }
                    />
                    {shiftList}
                  </div>
                  <div className="col-12">
                    <div className="row justify-content-center w-100 mt-3">
                      <div className="col-6 text-center">
                        <Button
                          btnType="General"
                          clicked={(event) => toggleFromDetails(event, false)}
                        >
                          برگشت
                        </Button>
                      </div>
                      <div className="col-6 text-center">
                        <Button btnType="Success" clicked={kioskSubmit}>
                          ثبت
                        </Button>
                      </div>
                    </div>
                  </div>
                </ContentForm>
              </div>
            </div>
          </div>
        </Fade>
      )}
    </div>
  );
};

export default KioskForm;
